import { useMemo } from "react";
import { useGet } from "../api/hooks";
import { ClinicalReviewResponse } from "../models/ClinicalReviewModel";

const useDashboardData = () => {
    const { data, loading, error, status } = useGet<ClinicalReviewResponse>(
        'dashboard\\clinicalreviews'
    );

    const urgentReviews = useMemo(
        () => data?.data.filter((review) => review.isUrgent && !review.isSubmitted) ?? [],
        [data]
    );

    const clinicalReviews = useMemo(
        () => data?.data.filter((review) => !review.isUrgent && !review.isSubmitted) ?? [],
        [data]
    );

    const submittedReviews = useMemo(
        () => data?.data.filter((review) => review.isSubmitted) ?? [],
        [data]
    );

    return {
        fullData: data,
        urgentReviews,
        clinicalReviews,
        submittedReviews,
        loading,
        error,
        status
    };
};

export default useDashboardData;
